module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "copyright"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Copyright © 2008 by Sanyika Shakur")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc.,"), _c('br'), _vm._v("841 Broadway, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("“Can’t C Me” © Copyright 1995 Sony/ATV Music Publishing LLC, Warner Tamerlane Publishing Corp., Goosehock Music. All rights on behalf of Sony/ATV Music Publishing LLC administered by Sony/ATV Music Publishing LLC, 8 Music Square West, Nashville, TN 37203. All rights reserved. Used by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("“So Many Tears,” words and music by Eric Baker, Gregory Jacobs, Tupac Shakur, and Stevie Wonder © Triboy Music c/o Missing Link Music LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This novel is entirely a work of fiction. The names, characters, and incidents portrayed in it are the work of the author’s imagination. Any resemblance to events, localities, or actual persons, living or dead, is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Published simultaneously in Canada"), _c('br'), _vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("eBook ISBN-13: 978-1-5558-4875-0")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("an imprint of Grove/Atlantic, Inc."), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.groveatlantic.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0